module.exports = __webpack_public_path__ + "assets/fill-1.ee97326c.svg";